import styled from 'styled-components';
import { IBootstrapTableColumnProps } from 'react-bootstrap-table-next';
import React from 'react';

const WrapBoldText = styled.span`
  white-space: pre-line;
`;

export function convertColumnsToWrapBoldText<T extends object>(
  columns: IBootstrapTableColumnProps<T>[]
): IBootstrapTableColumnProps<T>[] {
  return columns.map(({ text, ...rest }: IBootstrapTableColumnProps<T>) => ({
    ...rest,
    text: <WrapBoldText>{text}</WrapBoldText>,
  }));
}
